import React from "react";
import { hangarImage } from "../mock";
import { Button } from "./ui/button";

const chips = [
  "Aviation Cleaning Services",
  "Aircraft Detailing",
  "Hangar Cleaning",
  "Office Cleaning",
  "Janitorial Services",
  "Industrial & Warehouse",
  "Manufacturing Facility Cleaning",
  "Event & Venue Services",
  "Post-Construction Cleaning",
  "Move-In / Move-Out",
];

export default function ServicesList() {
  return (
    <section id="industries" className="py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="order-2 lg:order-1">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#e8a428] mb-4">
            What We Handle
          </p>
          <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#143527] mb-6">
            Built for the facilities other vendors avoid.
          </h2>
          <p className="text-[16px] text-[#143527]/75 leading-relaxed mb-8">
            Tidy Clean Up specializes in the demanding side of facility services. Our crews are trained for
            FBO ramps and hangars, occupied corporate offices, food-safe production floors, sensitive medical
            spaces and high-volume event venues — with the insurance, OSHA compliance and aviation-grade
            certifications to match.
          </p>

          <div className="flex flex-wrap gap-3 mb-8">
            {chips.map((chip) => (
              <span
                key={chip}
                className="px-5 py-2.5 rounded-full bg-[#f4ebde] border border-[#143527]/15 text-sm text-[#143527] hover:bg-[#d6e4be] hover:border-[#143527]/30 transition-colors cursor-pointer"
              >
                {chip}
              </span>
            ))}
          </div>

          <Button
            className="rounded-full px-7 py-6 btn-primary text-[15px]"
            onClick={() => {
              const el = document.getElementById("quote");
              if (el) el.scrollIntoView({ behavior: "smooth" });
            }}
          >
            Discuss your facility
          </Button>
        </div>

        <div className="order-1 lg:order-2 relative">
          <div className="relative aspect-[4/5] rounded-[2rem] overflow-hidden">
            <img
              src={hangarImage}
              alt="Private jet in a clean hangar"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -left-6 bg-[#e8a428] rounded-2xl p-5 shadow-lg hidden md:block">
            <div className="font-serif text-3xl text-[#143527] leading-none">24/7</div>
            <div className="text-xs text-[#143527]/80 mt-1">Crew availability</div>
          </div>
          <div className="absolute -top-6 -right-6 bg-[#d6e4be] rounded-2xl p-5 shadow-lg hidden md:block">
            <div className="font-serif text-3xl text-[#143527] leading-none">FAA</div>
            <div className="text-xs text-[#143527]/80 mt-1">Compliant practices</div>
          </div>
        </div>
      </div>
    </section>
  );
}
